import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import * as React from 'react';
import classnames from 'clsx';
import * as styles from './styles.css';
import { Portal } from '../Portal';
import { Tooltip } from '@cian/ui-kit';
import { pointTitleFromRoomCount } from '../../utils/pointTitleFromRoomCount';
import { polygonColorFromRoomCount } from '../../utils/polygonColorFromRoomCount';
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
export function Flat(_ref) {
  var id = _ref.id,
    hoveredFlatPlanId = _ref.hoveredFlatPlanId,
    roomCount = _ref.roomCount,
    tooltipPoint = _ref.tooltipPoint,
    polygonPath = _ref.polygonPath,
    containerWidth = _ref.containerWidth,
    containerHeight = _ref.containerHeight,
    tooltip = _ref.tooltip,
    onFlatOpen = _ref.onFlatOpen,
    onFlatHover = _ref.onFlatHover;
  var _React$useState = React.useState(false),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    hovered = _React$useState2[0],
    changeHovered = _React$useState2[1];
  var x = tooltipPoint.x,
    y = tooltipPoint.y;
  var relativeX = x / containerWidth * 100;
  var relativeY = y / containerHeight * 100;
  var setHovered = React.useCallback(function () {
    changeHovered(true);
    onFlatHover(id);
  }, [changeHovered]);
  var clearHovered = React.useCallback(function () {
    changeHovered(false);
    onFlatHover(null);
  }, [changeHovered]);
  var onClick = React.useCallback(function () {
    onFlatOpen(id);
    onFlatHover(null);
  }, [id]);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Portal, {
      children: /*#__PURE__*/_jsx("path", {
        onClick: onClick,
        fill: polygonColorFromRoomCount(roomCount),
        className: classnames(styles['polygon'], (id === hoveredFlatPlanId || hovered) && styles['polygon-hovered']),
        d: "M ".concat(polygonPath, " Z"),
        onMouseEnter: setHovered,
        onMouseLeave: clearHovered
      })
    }), /*#__PURE__*/_jsx("div", {
      className: styles['pin'],
      style: {
        left: "".concat(relativeX, "%"),
        top: "".concat(relativeY, "%")
      },
      onMouseEnter: setHovered,
      onMouseLeave: clearHovered,
      children: /*#__PURE__*/_jsx(Tooltip, {
        open: id === hoveredFlatPlanId || hovered,
        theme: "white",
        title: tooltip,
        children: /*#__PURE__*/_jsx("div", {
          className: classnames(styles['point'], hovered && styles['point-hovered']),
          "data-testid": "FlatPoint",
          children: pointTitleFromRoomCount(roomCount)
        })
      })
    })]
  });
}